const NAV_BOX_SELECTOR = '.mobile-nav-inner-box';

$(document)
    .on('click', '.mobile-nav-list__link-icon, .mobile-nav-inner-list__link-icon, .mobile-nav__list--companies .cursor-pointer', onClickNavLink)
    .on('click', '.mobile-nav-back-to-section__link', onClickNavBackLink)
    .on('click', '.mobile-nav-back-to-section__link--first', onClickNavBackLinkFirst);

const $navBoxes = $(NAV_BOX_SELECTOR);
const $navFooterContainer = $('.mobile-nav__footer');
const $navBodyContainer = $('.mobile-nav__body');
const $navLinkContainer = $('.mobile-nav-list__link');
const $navListContainer = $('.mobile-nav-inner-list');
const $navBackLinkContainer = $('.mobile-nav-back-to-section__link');

$(window).on(NLMK.events.DISABLED_MOBILE_NAVIGATION, function () {
    $navBoxes.removeClass('active');
});

$(window).resize(function() {
    const $activeNav = $('.mobile-nav-inner-box.active');
    calculateOffsetArrows($activeNav);
});

function onClickNavLink(evt) {
    const $innerBox = $(this)
        .closest('li') // li
        .children(NAV_BOX_SELECTOR);

    if ($innerBox.length) {
        $innerBox.addClass('active');
        calculateOffsetArrows($innerBox);

        if($navBoxes.hasClass('active')) {
            $navFooterContainer.addClass('hidden-menu');
            $navBodyContainer.addClass('hidden-menu');
            $navLinkContainer.addClass('hidden-link');
            $navListContainer.addClass('hidden-list');
        }

        evt.preventDefault();
    }
}

function onClickNavBackLink(evt) {
    $(this)
        .closest(NAV_BOX_SELECTOR)
        .removeClass('active');
    $navLinkContainer.removeClass('hidden-link'); // fix links visibility when inner menu is open;
    evt.preventDefault();
}

function onClickNavBackLinkFirst(evt) {
    evt.preventDefault();

    $navFooterContainer.removeClass('hidden-menu');
    $navBodyContainer.removeClass('hidden-menu');
    $navLinkContainer.removeClass('hidden-link');
    $navListContainer.removeClass('hidden-list');
}

function calculateOffsetArrows($container) {
    const $links = $container.find('.mobile-nav-inner-list__link');

    $links.each(function() {
        const $this = $(this);
        const $arrow = $this.find('.svg-symbol--arrow-long-right').parent('.mobile-nav-inner-list__link-icon');
        const widthLink = $this.width();

        if ($arrow.length) {
            $arrow.css('left', widthLink + 'px');
        }
    });
}



// WEBPACK FOOTER //
// ./js/main/module/head/mobile-nav.js